import React from 'react'
import { DateRangeFilterModal } from '../date-range-filter-modal/DateRangeFilterModal'
import {
  ModalFilterEntitiesEnum,
  ModalFilterEntitiesControlContext
} from '../entityFiltersModals'
import { useDateFilterContext } from '../dateFilter'

type FilterDateRangeModalProps = {}

export const FilterDateRangeModal: React.FC<FilterDateRangeModalProps> = () => {
  const [filter, changeFilter] = useDateFilterContext()
  const { activeModal, hide } = React.useContext(
    ModalFilterEntitiesControlContext
  )

  return (
    <DateRangeFilterModal
      isOpened={activeModal === ModalFilterEntitiesEnum.DATE}
      closeModal={hide}
      onFilterSubmit={changeFilter}
      {...filter}
    />
  )
}
